import {
  useState,
  useEffect,
  useRef,
  // createRef,
}                             from 'react';
import PropTypes              from 'prop-types';
import UILoader               from 'components/UI/Loader';
import { Form }               from 'formsy-semantic-ui-react';
import { Label, Button }      from 'semantic-ui-react';
import { useTranslation }     from 'next-i18next';
import VerificationCodeFields from 'components/Forms/VerificationCode';
import EmailInfoBlock         from 'components/Forms/EmailInfoBlock';
import isEmpty                from 'lodash/isEmpty';
import styles                 from './sign-in-form.module.scss';
import { useRouter }          from 'next/router';
import { SmartCaptcha }       from '@yandex/smart-captcha';
import getConfig              from 'next/config';
import EmailIcon              from '@material-ui/icons/Email';

const label = <Label color="red" pointing />;

const SignInForm = ({
  signIn,
  emailCode,
  authenticateByCode
}) => {
  const { t } = useTranslation('common');
  const [ email, setEmail ] = useState('');
  const [ step, setStep ] = useState('email'); // or 'code'
  const [ valid, setValid ] = useState(false);
  const [ authed, setAuthed ] = useState(false);
  const [ verificationCodeLoading, setVerificationCodeLoading ] = useState(false);
  const [ captchaToken, setCaptchaToken ] = useState(null);
  const router = useRouter();
  const deliveryTargetQueryParam = router.query.email;
  const instanceTimeoutRef = useRef(null);
  const isEmailStep = step === 'email';
  const isCodeStep = step === 'code';

  // ------------------------------------------------------

  useEffect(() => {
    if (deliveryTargetQueryParam) {
      setEmail(deliveryTargetQueryParam);
    }
    return () => {
      clearTimeout(instanceTimeoutRef.current);
      setCaptchaToken(null);
    }
  }, []);

  // ------------------------------------------------------

  const authenticate = (model) => {
    setStep('code');
    authenticateByCode(model).then(() => {
      setAuthed(true);
    })
  };

  // ------------------------------------------------------

  return (
    <div className={styles.root}>
      <UILoader active={signIn.loading || emailCode.loading} />

      <Form
        onInvalid={() => { setValid(false) }}
        onValid={() => { setValid(true) }}
        onValidSubmit={authenticate}
      >
        <If condition={(isEmailStep || !captchaToken)}>
          <Form.Input
            required
            autoComplete="off"
            className="email-input new-design no-label"
            placeholder="Email"
            name="email"
            iconPosition="left"
            validations={{ isEmail: true }}
            validationErrors={{
              isDefaultRequiredValue: t('formErrors.required'),
              isEmail: t('formErrors.isEmail')
            }}
            value={email}
            onChange={(event, { value }) => { setEmail(value) }}
            errorLabel={label}
          >
            <EmailIcon />
            <input />
          </Form.Input>

          {valid && (
            <SmartCaptcha
              sitekey={getConfig().publicRuntimeConfig.SMART_CAPTCHA_SITE_KEY}
              onSuccess={(value) => {
                setCaptchaToken(value);
                setStep('code');
              }}
            />
          )}
        </If>


        <If condition={isCodeStep && captchaToken}>
          <EmailInfoBlock
            email={email}
            onClickChangeEmail={() => {
              setEmail('');
              setStep('email');
              clearTimeout(instanceTimeoutRef.current);
              instanceTimeoutRef.current = setTimeout(() => {
                const input = document.querySelector('.email-input input');
                input.focus();
              }, 200);
            }}
          />

          <VerificationCodeFields
            autoFocus={true}
            email={email}
            captcha={captchaToken}
            onNotExistUserError={() => {
              setEmail('');
              setStep('email')
            }}
            onLoading={(value) => { setVerificationCodeLoading(value) }}
            scope="AUTHENTICATE_EMPLOYEE"
          />
        </If>

        <div className={styles.actions}>
          <button
            className="z-button button-lg full-width"
            color="teal"
            size="large"
            disabled={!valid || authed || verificationCodeLoading || isEmailStep}
          >
            {t('auth.submit')}
          </button>
        </div>
      </Form>
    </div>
  )
};

SignInForm.propTypes = {
  emailCode: PropTypes.object.isRequired,
  signIn: PropTypes.object.isRequired,
  authenticateByCode: PropTypes.func.isRequired
};

export default SignInForm;